import React, { Fragment, useContext, useEffect, useState } from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem/TimelineItem";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator/TimelineSeparator";
import TimelineDot from "@mui/lab/TimelineDot/TimelineDot";
import TimelineConnector from "@mui/lab/TimelineConnector/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent/TimelineContent";
import { Divider, Typography } from "@material-ui/core";
import Box from "@material-ui/core/Box";

import { Alert, AlertTitle, Tooltip } from "@mui/material";
import ReactMustache from "react-mustache";
import {
    formatDateCatchTimezone, formatDateToUKTimeZone, hoursMinFromTime, hoursMinToTimeString, StaffApprovalIcon
} from "../../contexts/BookingUtilities";
import { BookingConfigContext } from "../../contexts/BookingConfigContext";
import ParentApprovalIcon from "./BookingsCommon/ParentApprovalIcon";
import PointContextProvider, { PointContext } from "../../contexts/PointContext";
import { BrandContext } from "../../contexts/BrandContext";
import { BookMeATaxi } from "./BookingViews/TravelModes/Taxi/BookMeATaxi";
import axios from "../../utils/axios";
import { cWarn } from "./CustomLogger";


export default function BookingTimeline(props){


    const {booking} = props;
    const bookingConfig = useContext(BookingConfigContext);
    const brandContext = useContext(BrandContext);

    let studentToBookings=[];
    if(booking.studentToBookings){
        studentToBookings = booking.studentToBookings;
    }
    let cancellationData = null;

    const [dbData,setDbData] = useState(null);
    if(dbData !== null){
        if(dbData.booking.studentToBookings){
            studentToBookings = dbData.booking.studentToBookings;
        }
        if(dbData.cancelationData){
            cancellationData = dbData.cancelationData;
        }
    }


    const {
        id:bookingId
    } = booking;


    const {
        textContent:{
            bookingCancelled='',
            ipCreatedTip=''
        }
    } = brandContext;

    function DestinationPoint() {

        
        const pointContext = useContext(PointContext)
        
        const {
            destinationTimeLabel:timeLabel,
            destinationIcon:icon,
            destinationTitle:title,
            destinationBodyText:bodyText
        } = pointContext;

        return (
            <>
                <TimelineItem>
                    <TimelineOppositeContent
                        sx={{m: '10px 0'}}
                        align="right"
                        variant="body2"
                        color="text.secondary"
                    >
                        {timeLabel}
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineDot className="summaryLocationDot">
                            {icon}
                        </TimelineDot>
                        <TimelineConnector/>
                    </TimelineSeparator>
                    <TimelineContent sx={{py: '12px', px: 2}}>
                        <Typography className="summaryTreeTitle" variant="h6" component="span">
                            {title}
                        </Typography>
                        <div>{bodyText}</div>
                    </TimelineContent>
                </TimelineItem>
            </>
        );
    }

    function TransportPoint() {

        const pointContext = useContext(PointContext)

        const {
            point:{
                mode=''
            }
        } = pointContext;

        switch (mode){
            case 'bookMeATaxi':{
                return (<BookMeATaxi/>);
            }
            default:
            break;
        }


        const {
            transportTimeLabel:timeLabel,
            transportIcon:icon,
            transportTitle:title,
            transportBodyText:bodyText
        } = pointContext;

        return (
            <>
                <TimelineItem>
                    <TimelineOppositeContent
                        sx={{m: '10px 0'}}
                        align="right"
                        variant="body2"
                        color="text.secondary"
                    >
                        {timeLabel}
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                        <TimelineDot className="summaryModeDot">
                            {icon}
                        </TimelineDot>
                        <TimelineConnector/>
                    </TimelineSeparator>
                    <TimelineContent sx={{py: '12px', px:2}}>
                        <Typography className="summaryTreeTitle" variant="h6" component="span">
                            {title}
                        </Typography>
                        <div>{bodyText}</div>
                    </TimelineContent>
                </TimelineItem>
            </>
        );


    }

    const {
        bookingJson:{
            foreignOrigin=null,
            foreignDestination=null
        },
        dateCreated=null,
        createdIp=null
    } = booking;
    
    let mustGrabDbData = false;
    if(studentToBookings.length < 1){
        mustGrabDbData = true;
    }
    if(bookingCancelled){
        mustGrabDbData = true;   
    }

    /* eslint-disable */
    useEffect(() => {
        if(mustGrabDbData) {    
            // grab the student to bookings
            const apiPath = `${process.env.REACT_APP_API_URL}/studentbookings/id/${bookingId}`;

            axios.get(apiPath,{
                timeout: 300000,
                withCredentials:true
            }).then(res => {

                const {
                    data
                } = res;
                setDbData(data);
            }).catch(err => {
                cWarn(err); 
            });


        }
    },[]);
    /* eslint-enable */

    const CancellationBox = (props) => {
        let firstName = '';
        let lastName = '';
        let cancelNotes = '';
        const {
            dateStamp,
            user=null,
            notes=null
        } = props;

        if(user){
            ({firstName,lastName} = user);
        }
        if(notes){
            ({notes:cancelNotes} = notes);
        }
        return (
            <Alert severity="warning">
                <AlertTitle>{bookingCancelled} {formatDateCatchTimezone(dateStamp)} at {hoursMinToTimeString(hoursMinFromTime(dateStamp))} {user && `by`} {firstName} {lastName}</AlertTitle>
                {cancelNotes && <>{cancelNotes}</>}
            </Alert>
        );
    }

    const ipCreatedTipPopup = <ReactMustache Component="span" template={ipCreatedTip} data={{createdDate:formatDateToUKTimeZone(dateCreated),ip:createdIp}}/>;

    console.log(ipCreatedTipPopup);

    try {
        return (
            <Box>
                <Box sx={{display: 'flex', justifyContent: 'space-between' }}>
                    <Box sx={{flexGrow:1}}>
                        <Typography variant="h6">{formatDateCatchTimezone('date' in booking ? booking.date : booking.otherDate)}</Typography>
                        <Tooltip title={ipCreatedTipPopup}><Typography variant="Body2"><>Ref. {booking.id}</></Typography></Tooltip>
                    </Box>
                    <Box>
                        <StaffApprovalIcon booking={booking}/>
                        <ParentApprovalIcon booking={booking}/>
                    </Box>
                </Box>
                <Box pb={1}>
                    {studentToBookings &&
                    <>
                        {studentToBookings.map((studentRel,i) => {

                            let firstName = '';
                            let lastName = '';
                            const {
                                student,
                                staff,
                                contact
                            } = studentRel;
                            if(student){
                                ({firstName='',lastName=''} = student);
                            }
                            if(contact){
                                ({firstName='',lastName=''} = contact);
                            }
                            if(staff){
                                ({firstName='',lastName=''} = staff);
                            }

                            return(
                            <Box key={i}>
                                {firstName} {lastName}
                            </Box>
                            );
                        })}
                    </>
                    }
                </Box>
                {cancellationData &&
                    <CancellationBox {...cancellationData} />
                }
                <Divider />
                <Timeline position="alternate" sx={{paddingLeft:0, paddingRight:0}}>
                    {
                        foreignOrigin !== null &&
                        <PointContextProvider
                            point={foreignOrigin} 
                            booking={booking} 
                            index="origin"
                            bookingConfig={bookingConfig}
                            brandContext={brandContext}
                        >
                            <DestinationPoint  />
                        </PointContextProvider>
                    }
                    <PointContextProvider
                        point={booking.bookingJson.origin} 
                        booking={booking} 
                        index="origin"
                        bookingConfig={bookingConfig}
                        brandContext={brandContext}
                    >
                        <DestinationPoint  />
                    </PointContextProvider>
                    {booking.bookingJson.legs.map((leg, index) => (
                        <Fragment key={index}>
                            <PointContextProvider
                                point={leg} 
                                booking={booking} 
                                index={index}
                                bookingConfig={bookingConfig}
                                brandContext={brandContext}
                            >
                                <TransportPoint/>
                                <DestinationPoint />
                            </PointContextProvider>
                        </Fragment>
                    ))}
                    {booking.bookingJson.legs.length === 0 &&
                        <PointContextProvider
                            point={booking.bookingJson.destination} 
                            booking={booking} 
                            index="destination"
                            bookingConfig={bookingConfig}
                            brandContext={brandContext}
                        >
                            <DestinationPoint />
                        </PointContextProvider>
                    }
                    {
                        foreignDestination !== null &&
                        <PointContextProvider
                            point={foreignDestination} 
                            booking={booking} 
                            index="origin"
                            bookingConfig={bookingConfig}
                            brandContext={brandContext}
                        >
                            <DestinationPoint  />
                        </PointContextProvider>
                    }
                </Timeline>

                {booking.bookingJson.bookingNotes &&
                <Box>
                    <Typography>{booking.bookingJson.bookingNotes}</Typography>
                </Box>
                }

            </Box>
        );
    }
    catch(e){
        console.warn(e);
    }
} 